





































import { computed, defineComponent } from '@vue/composition-api'
import { mdiStar } from '@mdi/js'
import AIcon from '@/components/AIcon'

const maxStars = 5

export default defineComponent({
  name: 'AStarRating',

  components: { AIcon },

  props: {
    value: {
      type: Number,
      required: true,
    },
    small: {
      type: Boolean,
      default: false,
    },
    large: {
      type: Boolean,
      default: false,
    },
  },

  setup(props) {
    const valueInPercent = computed(() => {
      return ((100 / maxStars) * props.value).toFixed(2)
    })

    return { maxStars, valueInPercent, mdiStar }
  },
})
